const CHECK_INTERVAL_MS = 60 * 1000;

export function shouldReload(currentBuildId: string, fetchedBuildId: string | undefined): boolean {
  if (!fetchedBuildId) return false;
  if (!currentBuildId) return false;
  return currentBuildId !== fetchedBuildId;
}

async function fetchBuildId(): Promise<string | undefined> {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) return undefined;
    const data: unknown = await res.json();
    if (
      data &&
      typeof data === 'object' &&
      'buildId' in data &&
      typeof (data as { buildId: unknown }).buildId === 'string'
    ) {
      return (data as { buildId: string }).buildId;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

let reloading = false;

async function forceReload() {
  if (reloading) return;
  reloading = true;
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if ('caches' in globalThis) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } finally {
    globalThis.location.reload();
  }
}

async function checkAndReload() {
  const fetched = await fetchBuildId();
  if (shouldReload(__BUILD_ID__, fetched)) {
    await forceReload();
  }
}

export function startVersionCheck() {
  void checkAndReload();
  setInterval(() => {
    void checkAndReload();
  }, CHECK_INTERVAL_MS);

  if (typeof globalThis.document !== 'undefined') {
    globalThis.document.addEventListener('visibilitychange', () => {
      if (!globalThis.document.hidden) void checkAndReload();
    });
  }
  globalThis.addEventListener('focus', () => {
    void checkAndReload();
  });
}
